import { render, staticRenderFns } from "./BusinessUsePercentage.vue?vue&type=template&id=7540dd64&"
import script from "./BusinessUsePercentage.vue?vue&type=script&lang=js&"
export * from "./BusinessUsePercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports